import Icon from '../components/Icon.vue'

Icon.register({"laptop":{"width":640,"height":512,"paths":[{"d":"M624 416H381.5C380.8 435.8 366.8 448 348.8 448H288C269.3 448 255 430.5 255.2 416H16C7.2 416 0 423.2 0 432V448C0 483.2 28.8 512 64 512H576C611.2 512 640 483.2 640 448V432C640 423.2 632.8 416 624 416zM576 48C576 21.6 554.4 0 528 0H112C85.6 0 64 21.6 64 48V384H576V48zM512 320H128V64H512V320z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/laptop.js
// module id = null
// module chunks = 